import type { ReceiptTemplate } from '../schema';

export const lululemonTemplate: ReceiptTemplate = {
  id: 'lululemon',
  name: 'Lululemon Receipt',
  brand: 'LULULEMON',
  description: 'Lululemon athletic apparel receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'lulu-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/lululemon.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lulu-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store:', value: '4892' },
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'educator', label: 'Educator:', value: 'MIKE W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lulu-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'ALIGN HR PANT 25"', quantity: '1', price: '98.00', sku: 'LW5CTLS' },
          { id: '2', name: 'SWIFTLY TECH LS 2.0', quantity: '1', price: '78.00', sku: 'LW3DQBS' },
          { id: '3', name: 'ENERGY BRA HN LL', quantity: '1', price: '52.00', sku: 'LW2AXCS' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lulu-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '228.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '18.81', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '246.81', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lulu-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lulu-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'QUALITY GUARANTEE\nReturn within 30 days\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

